/* ==========================================================================
   KARIKO — shared behaviour
   Progressive enhancement: every page is complete without JS; this wires
   up the mobile nav, product configurator, cart steppers and forms.
   ========================================================================== */
(function () {
  "use strict";

  /* ---- Mobile navigation ------------------------------------------------ */
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var panel = document.querySelector("[data-mobile-nav]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- Shared cart helpers ----------------------------------------------- */
  function money(n) {
    return "$" + Math.round(n).toLocaleString("en-AU");
  }

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---- Product configurator (real Shopify variants) --------------------- */
  function cdnUrl(src, width) {
    if (!src) return "";
    var url = src.indexOf("http") === 0 ? src : "https:" + src;
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    return url + sep + "width=" + width;
  }

  // Compare two CDN urls ignoring their query strings
  function sameImage(a, b) {
    if (!a || !b) return false;
    return a.split("?")[0].replace(/^https?:/, "") === b.split("?")[0].replace(/^https?:/, "");
  }

  function initConfigurator(root) {
    // The gallery is a sibling of the configurator, so look them up from the
    // shared product-layout wrapper rather than from inside the configurator.
    var scope = root.closest(".product-layout") || document;
    var mainImg = scope.querySelector("[data-gallery-main]");
    var thumbs = scope.querySelectorAll(".thumb");
    var priceEls = root.querySelectorAll("[data-price]");
    var addBtn = root.querySelector("[data-add-to-cart]");
    var form = root.querySelector('form[action*="/cart/add"]');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var dataEl = document.getElementById("product-variants-data");
    var variants = [];
    try {
      variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var selectedVariant = null;

    // Group option buttons by their option index (0 = first product option, 1 = second, ...)
    var groups = {};
    root.querySelectorAll("[data-option-value]").forEach(function (btn) {
      var idx = btn.getAttribute("data-index");
      (groups[idx] = groups[idx] || []).push(btn);
    });
    var indices = Object.keys(groups).sort(function (a, b) { return a - b; });
    var timberIndex = -1, widthIndex = -1, configIndex = -1;
    indices.forEach(function (idx) {
      var first = groups[idx][0];
      if (first.classList.contains("swatch")) timberIndex = parseInt(idx, 10);
      else if (first.classList.contains("pill--sm")) configIndex = parseInt(idx, 10);
      else widthIndex = parseInt(idx, 10);
    });

    /* ---- Benchtop upgrade -------------------------------------------------
       Timber top is included. A stone top adds a separate, priced line to the
       cart, because Shopify caps a product at 3 options and Size/Timber/
       Configuration already use all three. */
    var benchtopBtns = root.querySelectorAll("[data-benchtop]");
    var benchtopProp = root.querySelector("[data-benchtop-prop]");
    var benchtopLabelEl = root.querySelector("[data-benchtop-label]");
    var benchtopPricing = readJson("benchtop-pricing-data");
    var benchtopAddons = readJson("benchtop-addon-data");
    var timberSwatches = readJson("timber-swatch-data");
    var timberBenchtopImg = root.querySelector("[data-timber-benchtop-img]");
    var timberBenchtopName = root.querySelector("[data-timber-benchtop-name]");

    function readJson(id) {
      var el = document.getElementById(id);
      if (!el) return {};
      try { return JSON.parse(el.textContent); } catch (e) { return {}; }
    }

    function activeBenchtop() {
      return root.querySelector("[data-benchtop].is-active") || benchtopBtns[0] || null;
    }

    function upchargeFor(tier) {
      if (!tier || tier === "timber") return 0;
      var sel = selection();
      var timber = timberIndex !== -1 ? sel[timberIndex] : null;
      var width = widthIndex !== -1 ? sel[widthIndex] : null;
      // Flat "tier|timber|width" keys — nested JSON can't live in a theme
      // setting, because Shopify reads the resulting "}}" as Liquid.
      if (!timber || !width) return 0;
      return parseInt(benchtopPricing[tier + "|" + timber + "|" + width], 10) || 0;
    }

    function currentUpcharge() {
      var b = activeBenchtop();
      return b ? upchargeFor(b.getAttribute("data-tier")) : 0;
    }

    function updateBenchtops() {
      var active = activeBenchtop();
      benchtopBtns.forEach(function (b) {
        var priceEl = b.querySelector("[data-benchtop-add]");
        if (!priceEl) return;
        var amt = upchargeFor(b.getAttribute("data-tier"));
        priceEl.textContent = amt > 0 ? "+" + money(amt) : "Included";
      });
      // The timber benchtop mirrors whichever species is selected for the vanity
      var timber = timberIndex !== -1 ? selection()[timberIndex] : null;
      if (timber) {
        var timberBtn = root.querySelector('[data-benchtop][data-tier="timber"]');
        if (timberBenchtopImg && timberSwatches[timber]) {
          timberBenchtopImg.src = timberSwatches[timber];
          timberBenchtopImg.alt = timber + " timber top";
        }
        if (timberBenchtopName) timberBenchtopName.textContent = timber + " top";
        if (timberBtn) timberBtn.setAttribute("data-name", timber + " top");
      }

      if (active) {
        var name = active.getAttribute("data-name") || "";
        var amt = upchargeFor(active.getAttribute("data-tier"));
        if (benchtopProp) benchtopProp.value = amt > 0 ? name + " (+" + money(amt) + ")" : name;
        if (benchtopLabelEl) benchtopLabelEl.textContent = name;
      }
    }

    benchtopBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        benchtopBtns.forEach(function (o) { o.classList.remove("is-active"); });
        b.classList.add("is-active");
        recalc();
      });
    });

    function selectIn(group, el) {
      var items = root.querySelectorAll(group);
      for (var i = 0; i < items.length; i++) items[i].classList.remove("is-active");
      el.classList.add("is-active");
    }

    function selection() {
      return indices.map(function (idx) {
        var active = groups[idx].filter(function (b) { return b.classList.contains("is-active"); })[0];
        return active ? active.getAttribute("data-value") : null;
      });
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && opts[j] !== sel[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    // Is there any real variant with this value at this option index, given the OTHER current selections?
    function valueIsAvailable(idx, value, sel) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (opts[idx] !== value) continue;
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (j === idx || sel[j] === null) continue;
          if (opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    // Options resolve in priority order: width is always free to choose, the
    // configurations are then narrowed to those that exist at that width, and
    // the timber swatches are tested against the resulting width + config.
    var resolveOrder = (function () {
      var order = [];
      [widthIndex, configIndex, timberIndex].forEach(function (i) {
        if (i !== -1) order.push(i);
      });
      indices.forEach(function (idx) {
        var i = parseInt(idx, 10);
        if (order.indexOf(i) === -1) order.push(i);
      });
      return order;
    })();

    function resolve() {
      var fixed = indices.map(function () { return null; });

      resolveOrder.forEach(function (i) {
        var btns = groups[String(i)];
        if (!btns) return;

        var firstAvailable = null, active = null;
        btns.forEach(function (btn) {
          var ok = valueIsAvailable(i, btn.getAttribute("data-value"), fixed);
          btn.classList.toggle("is-unavailable", !ok);
          // Configurations that don't exist at this width are hidden outright
          if (i === configIndex) btn.hidden = !ok;
          if (ok && !firstAvailable) firstAvailable = btn;
          if (btn.classList.contains("is-active")) active = btn;
        });

        // Keep the current choice when it still exists, otherwise take the first that does
        if ((!active || active.classList.contains("is-unavailable")) && firstAvailable) {
          btns.forEach(function (b) { b.classList.remove("is-active"); });
          firstAvailable.classList.add("is-active");
          active = firstAvailable;
        }
        if (active) fixed[i] = active.getAttribute("data-value");
      });
    }

    // Timber swatch thumbnails — show the real product photo for each timber
    // Fallback only: species swatches normally come from theme blocks and are
    // rendered server-side. This fills any swatch left without one.
    function updateSwatchImages() {
      if (timberIndex === -1) return;
      var sel = selection();
      groups[timberIndex].forEach(function (btn) {
        var img = btn.querySelector("[data-swatch-img]");
        if (!img) return;
        var value = btn.getAttribute("data-value");
        if (timberSwatches[value]) {
          img.src = timberSwatches[value];
          img.hidden = false;
          return;
        }
        var trySel = sel.slice();
        trySel[timberIndex] = value;
        var v = findVariant(trySel);
        if (!v) {
          for (var i = 0; i < variants.length; i++) {
            if ((variants[i].options || [])[timberIndex] === value) { v = variants[i]; break; }
          }
        }
        if (v && v.featured_image && v.featured_image.src) {
          img.src = cdnUrl(v.featured_image.src, 300);
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      });
    }

    function recalc() {
      resolve();

      var sel = selection();
      selectedVariant = findVariant(sel);

      // Keep the form's variant id in step with the selection
      if (variantInput && selectedVariant) variantInput.value = selectedVariant.id;

      updateBenchtops();

      var base = selectedVariant ? parseFloat(selectedVariant.price) / 100 : 0;
      var total = base + currentUpcharge();
      for (var i = 0; i < priceEls.length; i++) priceEls[i].textContent = money(total);
      if (addBtn) {
        var available = selectedVariant && selectedVariant.available !== false;
        addBtn.disabled = !available;
        addBtn.classList.toggle("is-disabled", !available);
      }

      if (mainImg && selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src) {
        var newSrc = cdnUrl(selectedVariant.featured_image.src, 1800);
        mainImg.src = newSrc;
        // Highlight the matching thumbnail if this photo is one of them
        thumbs.forEach(function (t) {
          t.classList.toggle("is-active", sameImage(t.getAttribute("data-img"), newSrc));
        });
      }

      if (timberIndex !== -1) {
        var label = root.querySelector("[data-timber-label]");
        var activeTimber = groups[timberIndex].filter(function (b) { return b.classList.contains("is-active"); })[0];
        if (label && activeTimber) label.textContent = (activeTimber.getAttribute("data-value") || "").toUpperCase();
      }

      if (configIndex !== -1) {
        var cLabel = root.querySelector("[data-config-label]");
        var activeConfig = groups[configIndex].filter(function (b) { return b.classList.contains("is-active"); })[0];
        if (cLabel) cLabel.textContent = activeConfig ? activeConfig.getAttribute("data-value") : "";
      }

      // Generic option labels on the default product template
      indices.forEach(function (idx) {
        var label = root.querySelector('[data-option-label="' + idx + '"]');
        if (!label) return;
        var active = groups[idx].filter(function (b) { return b.classList.contains("is-active"); })[0];
        if (active) label.textContent = active.getAttribute("data-value");
      });

      updateSwatchImages();
    }

    // Any option button — width/size, timber swatch, or configuration pill
    root.querySelectorAll("[data-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-unavailable")) return;
        var idx = btn.getAttribute("data-index");
        selectIn('[data-index="' + idx + '"]', btn);
        recalc();
      });
    });

    // Gallery thumbnails
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (o) { o.classList.remove("is-active"); });
        t.classList.add("is-active");
        var src = t.getAttribute("data-img") || t.querySelector("img").src;
        if (mainImg) mainImg.src = src;
      });
    });

    // Add to cart — submit the real form so any fields an app injected
    // (custom options, line item properties) are posted along with it.
    if (form) {
      form.addEventListener("submit", function (e) {
        // If a product-options app is handling this submit itself, stay out of the way
        if (e.defaultPrevented) return;
        e.preventDefault();

        if (!form.checkValidity()) { form.reportValidity(); return; }

        var originalText = addBtn ? addBtn.textContent : "";
        if (addBtn) addBtn.disabled = true;

        // Pull every properties[...] field, including any an app injected
        var props = {};
        new FormData(form).forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && String(value).trim() !== "") props[m[1]] = value;
        });

        var items = [{
          id: variantInput ? variantInput.value : (selectedVariant && selectedVariant.id),
          quantity: 1,
          properties: props
        }];

        // Stone benchtop rides along as its own priced line
        var upcharge = currentUpcharge();
        var addonId = benchtopAddons[String(upcharge)];
        if (upcharge > 0 && addonId) {
          items.push({
            id: addonId,
            quantity: 1,
            properties: {
              // Clean finish name only - the upcharge is already shown as the line price
              "Benchtop": (function () { var b = activeBenchtop(); return (b && b.getAttribute("data-name")) || props["Benchtop"] || ""; })(),
              "For": (selectedVariant && selectedVariant.name) || document.title
              // Carry the chosen stone's swatch through so the cart shows the right image
              , "_BenchtopImage": (function () { var b = activeBenchtop(); var i = b && b.querySelector("img"); return (i && i.src) || ""; })()
            }
          });
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return fetch("/cart.js");
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (!addBtn) return;
            addBtn.textContent = "Added ✓";
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            if (!addBtn) return;
            addBtn.textContent = "Couldn't add — try again";
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1800);
          });
      });
    }

    recalc();
  }

  function initConfigurators() {
    document.querySelectorAll("[data-configurator]").forEach(initConfigurator);
  }

  /* ---- Gallery thumbnail carousel --------------------------------------- */
  function initThumbCarousel(wrap) {
    var track = wrap.querySelector("[data-thumb-track]");
    var prev = wrap.querySelector("[data-thumb-prev]");
    var next = wrap.querySelector("[data-thumb-next]");
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 4;
      prev.hidden = !scrollable || track.scrollLeft <= 4;
      next.hidden = !scrollable || track.scrollLeft >= max - 4;
    }

    function page(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: "smooth" });
    }

    prev.addEventListener("click", function () { page(-1); });
    next.addEventListener("click", function () { page(1); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initThumbCarousels() {
    document.querySelectorAll("[data-thumbs]").forEach(initThumbCarousel);
  }

  /* ---- Cart quantity steppers (real Shopify cart) ------------------------ */
  function initCart() {
    var cart = document.querySelector("[data-cart]");
    if (!cart) return;

    function changeLine(line, quantity) {
      cart.classList.add("is-loading");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { cart.classList.remove("is-loading"); });
    }

    cart.querySelectorAll("[data-line]").forEach(function (lineEl) {
      var line = parseInt(lineEl.getAttribute("data-line"), 10);
      var val = lineEl.querySelector("[data-qty-val]");
      lineEl.querySelector("[data-qty-inc]").addEventListener("click", function () {
        var n = (parseInt(val.textContent, 10) || 1) + 1;
        changeLine(line, n);
      });
      lineEl.querySelector("[data-qty-dec]").addEventListener("click", function () {
        var n = (parseInt(val.textContent, 10) || 1) - 1;
        changeLine(line, n < 0 ? 0 : n);
      });
    });
  }

  /* ---- Demo forms (no backend) ----------------------------------------- */
  function initForms() {
    document.querySelectorAll("form[data-demo-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var note = form.querySelector("[data-form-note]");
        if (note) { note.hidden = false; }
        form.reset();
      });
    });
  }

  /* ---- Boot ------------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    initNav();
    initThumbCarousels();
    initConfigurators();
    initCart();
    initForms();
  });
})();
